(() => {
  const videoSelector = 'video.video-lazyload';
  const imageSelector = 'img.lazyload[data-src]';
  const selector = `${videoSelector}, ${imageSelector}`;
  const animationSelector = '.scroll-animation, .scroll-animation-05';
  const observed = new WeakSet();
  let frameQueued = false;

  function loadVideo(video) {
    if (!video || video.dataset.ukVideoReady === 'true' || video.getClientRects().length === 0) return;

    const source = video.querySelector('source[data-src]');
    if (!source?.dataset.src) return;

    if (!video.poster && video.dataset.poster) {
      video.poster = video.dataset.poster;
    }

    source.src = source.dataset.src;
    video.dataset.ukVideoReady = 'true';
    video.load();
  }

  function loadImage(image) {
    if (!image?.dataset.src || image.dataset.ukImageReady === 'true') return;

    image.src = image.dataset.src;
    image.dataset.ukImageReady = 'true';
  }

  function loadMedia(element) {
    if (element.matches(videoSelector)) {
      loadVideo(element);
    } else if (element.matches(imageSelector)) {
      loadImage(element);
    }
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        loadMedia(entry.target);
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '200px 0px' }
  );

  function scan(root = document) {
    root.querySelectorAll(selector).forEach((element) => {
      if (
        element.dataset.ukVideoReady === 'true'
        || element.dataset.ukImageReady === 'true'
      ) return;

      const rect = element.getBoundingClientRect();
      if (element.getClientRects().length && rect.top < window.innerHeight + 200 && rect.bottom > -200) {
        loadMedia(element);
      } else if (!observed.has(element)) {
        observed.add(element);
        observer.observe(element);
      }
    });

    root.querySelectorAll(animationSelector).forEach((element) => {
      if (element.classList.contains('active') || element.getClientRects().length === 0) return;

      const rect = element.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.8) {
        element.classList.add('active');
      }
    });
  }

  function queueScan() {
    if (frameQueued) return;

    frameQueued = true;
    window.requestAnimationFrame(() => {
      frameQueued = false;
      scan();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scan(), { once: true });
  } else {
    scan();
  }

  document.addEventListener('click', (event) => {
    if (event.target.closest('.openfitpro_section7 .video_control .item')) {
      window.setTimeout(queueScan, 0);
    }
  });
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
  window.addEventListener('scroll', queueScan, { passive: true });
  window.addEventListener('resize', queueScan, { passive: true });
})();
